import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {PolicyAreaSearch} from "./PolicyAreaSearch";
import * as _ from "lodash";


const vUI_Policy_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_POLICY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Policy Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    POLICY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'ID', columnResourceName: 'colPolicyId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    POLICY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Name', columnResourceName: 'colPolicyName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    WB_POLICYAREA_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Policy Area Id',
            columnResourceName: 'colwbPAId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    POLICYAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Policy Area', columnResourceName: 'colPolicyArea', alignment: HorizAlignment.Left},
        domainOptions: {
            search: PolicyAreaSearch,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    POLICYAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Policy Area ID', columnResourceName: 'colPolicyAreaId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Company Id',
            columnResourceName: 'colwbSalesOrgId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    SALESORG: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colComapnyId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    COMMENTS: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Description', columnResourceName: 'colComments', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 5000}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }

};

const PolicySearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_POLICY_ID',
        id_ui: 'POLICY_ID',
        name: 'POLICY_NAME'
    },

    searchProviderFields: vUI_Policy_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                  searchRequestSubset.where['WB_SALESORG_ID'] = {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Policy_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    }
};

const PolicySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "PolicySearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'ID', searchProviderFieldId: 'POLICY_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'POLICY_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'POLICY_ID', 'SALESORG', 'POLICY_NAME', 'POLICYAREA_NAME','COMMENTS',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PolicySearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PolicySearch: ISearch = {
    searchName: "Find Policy",
    renderOptions: {ui5ResourceId: "PolicySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PolicySearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("PolicyBO", "Policy", PolicySearch, "Policy Search")

export {PolicySearch}

